(function () {
  const core = window.MdaCartGiftCore;
  const schedule = window.MdaSchedule;
  if (!core || !schedule || window.__mdaCartGiftLoaded) return;
  window.__mdaCartGiftLoaded = true;

  const tz = (window.MDA_SCHEDULE && window.MDA_SCHEDULE.tz) || 'America/New_York';
  const SUPPRESS_KEY = 'mda_gift_suppressed';
  let suppressed = false;
  let busy = false;
  let pending = false;

  function readSuppressed() {
    if (suppressed) return true;
    try { suppressed = window.sessionStorage.getItem(SUPPRESS_KEY) === '1'; } catch (e) { /* storage blocked */ }
    return suppressed;
  }

  function suppress() {
    suppressed = true;
    try { window.sessionStorage.setItem(SUPPRESS_KEY, '1'); } catch (e) { /* storage blocked */ }
  }

  function post(url, body) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + url : '/' + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function apply(action) {
    if (action.type === 'add') {
      const properties = {};
      properties[core.GIFT_PROP] = core.GIFT_TAG;
      return post('cart/add.js', { items: [{ id: action.variantId, quantity: 1, properties: properties }] });
    }
    if (action.type === 'remove') return post('cart/change.js', { id: action.key, quantity: 0 });
    if (action.type === 'set') return post('cart/change.js', { id: action.key, quantity: action.quantity });
    return Promise.resolve(null);
  }

  function showOfferNote() {
    const text = window.MDA_GIFT && window.MDA_GIFT.offerNote;
    if (!text) return;
    let note = document.getElementById('mda-offer-note');
    if (!note) {
      note = document.createElement('div');
      note.id = 'mda-offer-note';
      note.className = 'mda-offer-note';
      note.setAttribute('role', 'status');
      document.body.appendChild(note);
    }
    note.textContent = text;
    note.hidden = false;
    clearTimeout(showOfferNote.timer);
    showOfferNote.timer = setTimeout(function () { note.hidden = true; }, 7000);
  }

  function run() {
    if (busy) {
      pending = true;
      return;
    }
    const rule = core.giftRule(window.MDA_GIFT, schedule.nowStamp(new Date(), tz), schedule.isActive);
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const offer = core.offerAction(cart);
        if (offer.type === 'codes') {
          return post('cart/update.js', { discount: offer.codes.join(',') }).then(function () {
            showOfferNote();
            pending = true;
            if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          });
        }
        const action = core.giftAction(cart, rule, { suppressed: readSuppressed() });
        if (action.suppress) suppress();
        if (action.type === 'none') return null;
        return apply(action).then(function () {
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        // An event arrived mid-run: reconcile once more. giftAction is idempotent, so this settles.
        if (pending) {
          pending = false;
          run();
        }
      });
  }

  if (typeof window.upcartSubscribeCartUpdated === 'function') window.upcartSubscribeCartUpdated(run);
  else {
    // UpCart may initialise after this script; try once more shortly after load.
    window.addEventListener('load', function () {
      if (typeof window.upcartSubscribeCartUpdated === 'function') window.upcartSubscribeCartUpdated(run);
    });
  }
  document.addEventListener('mda:schedule-applied', run);
  run();
})();
